import { variables } from '@bitrise/bitkit';
import { VizContext, useTicks } from '@bitrise/bitviz';
import uniqBy from 'lodash.uniqby';
import React, { useContext, FunctionComponent } from 'react';

const SessionTraceVisualisationStripes: FunctionComponent = () => {
  const {
    artboardHeight,
    artboardLeft,
    artboardRight,
    artboardTop,
    xDomain,
    xScale,
    yDomain,
  } = useContext(VizContext);

  const { ticks } = useTicks({
    scale: xScale,
    x0: xDomain[0],
    x1: xDomain[xDomain.length - 1],
    y0: yDomain[0],
    y1: yDomain[0],
  });

  const finalStripe = [xDomain[xDomain.length - 1], artboardRight];

  return (
    <g>
      {uniqBy([...ticks, finalStripe], ([t]) => t).map(([tick, px], index) => (
        <rect
          fill={index % 2 ? variables.colorGray1 : variables.colorWhite}
          height={artboardHeight}
          key={tick}
          width={px - (ticks[index - 1] ? ticks[index - 1][1] : artboardLeft)}
          x={ticks[index - 1] ? ticks[index - 1][1] : artboardLeft}
          y={artboardTop}
        />
      ))}
    </g>
  );
};

export default SessionTraceVisualisationStripes;
